import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-c5e3a9b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "ap-table",
  style: {"overflow-x":"initial !important"}
}
const _hoisted_3 = {
  class: "ap-table-row ap-table-header",
  style: {"margin-bottom":"10px"}
}
const _hoisted_4 = {
  key: 0,
  class: "ap-table",
  ref: "tableBody",
  style: {"overflow":"hidden"}
}
const _hoisted_5 = {
  key: 0,
  class: ""
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "ap-checkmark ap-icon ap-icon-check color-white" }, null, -1))
const _hoisted_9 = [
  _hoisted_8
]
const _hoisted_10 = { key: 1 }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "lp_image_wrapper p-relative d-block" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "item-overlay" }, null, -1))
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "lp_title" }
const _hoisted_16 = {
  key: 0,
  class: "lp_text"
}
const _hoisted_17 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "ap-btn btn-circle circle-sm",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-arrow-md-left" })
], -1))
const _hoisted_18 = [
  _hoisted_17
]
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", {
  class: "ap-btn btn-circle circle-sm",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "ap-icon ap-icon-arrow-md-right" })
], -1))
const _hoisted_20 = [
  _hoisted_19
]
const _hoisted_21 = {
  key: 1,
  class: "temp-rows"
}
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_26 = { class: "temp-rows-loader" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ap_tab = _resolveComponent("ap-tab")!
  const _component_icon_input = _resolveComponent("icon-input")!
  const _component_swiper_slide = _resolveComponent("swiper-slide")!
  const _component_swiper = _resolveComponent("swiper")!
  const _component_ap_loader = _resolveComponent("ap-loader")!
  const _component_ap_button = _resolveComponent("ap-button")!
  const _component_ApModalBase = _resolveComponent("ApModalBase")!
  const _directive_width = _resolveDirective("width")!

  return (_openBlock(), _createBlock(_component_ApModalBase, {
    name: _ctx.name,
    titleIcon: 'ap-icon-template_icon',
    title: _ctx.$t('page.send-email.content.message-action.template'),
    showClose: true,
    width: 980,
    height: null,
    onOpen: _ctx.beforeOpen,
    "cancel-text": _ctx.$t('modal.close')
  }, {
    "fixed-top": _withCtx(() => [
      (_ctx.isEmail)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createVNode(_component_ap_tab, {
              name: false,
              type: "ap-filter-tab",
              modelValue: _ctx.requestFilter.IsTextTemplate,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.requestFilter.IsTextTemplate) = $event)),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changeType(false))),
              onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onSearch(true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('page.email-list.filter-tab.designed-templates')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"]),
            _createVNode(_component_ap_tab, {
              name: true,
              type: "ap-filter-tab",
              modelValue: _ctx.requestFilter.IsTextTemplate,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.requestFilter.IsTextTemplate) = $event)),
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.changeType(true))),
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onSearch(true)))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('page.email-list.filter-tab.text-templates')), 1)
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_component_icon_input, {
        class: "ap-input-search mb12",
        style: {"max-width":"380px"},
        "input-class": "w-100",
        placeholder: _ctx.$t('page.sms-list.template-tab.filter.keywords'),
        icon: "ap-icon-search",
        onEnter: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onFilter())),
        modelValue: _ctx.filter,
        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.filter) = $event)),
        onIconClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.onFilter()))
      }, null, 8, ["placeholder", "modelValue"]),
      (!_ctx.isEmail || _ctx.requestFilter.IsTextTemplate)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives((_openBlock(), _createElementBlock("div", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('page.send-email.content.campaign.title')), 1)
              ])), [
                [_directive_width, 290]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('page.emails-list.profile-tab.table.title.date')), 1)
              ])), [
                [_directive_width, 290]
              ]),
              _withDirectives((_openBlock(), _createElementBlock("div", null, [
                _createTextVNode(_toDisplayString(_ctx.$t('blockManager.labels.text')), 1)
              ])), [
                [_directive_width, 275]
              ]),
              _withDirectives(_createElementVNode("div", null, null, 512), [
                [_directive_width, 25]
              ])
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    footer: _withCtx(() => [
      _createVNode(_component_ap_button, {
        "btn-class": "btn-primary",
        disabled: _ctx.selectedRow == null,
        onClick: _ctx.saveSelectedTemplate
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('page.automation.btn.SelectTemplate')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "onClick"])
    ]),
    default: _withCtx(() => [
      (_ctx.loaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            (!_ctx.isEmail || _ctx.requestFilter.IsTextTemplate)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRows, (row) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: _normalizeClass(["ap-table-row ap-table-content", _ctx.selectedRow && _ctx.selectedRow.Id === row.Id ? 'selected' : '']),
                      key: row.Id,
                      onClick: ($event: any) => (_ctx.selectTemplate(row))
                    }, [
                      _withDirectives((_openBlock(), _createElementBlock("div", null, [
                        _createTextVNode(_toDisplayString(row.Name), 1)
                      ])), [
                        [_directive_width, 290]
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("div", null, [
                        _createTextVNode(_toDisplayString(_ctx.momentchat(row.CreatedAt, 'DD/MM/YYYY HH:mm')), 1)
                      ])), [
                        [_directive_width, 290]
                      ]),
                      _withDirectives((_openBlock(), _createElementBlock("div", null, [
                        _createTextVNode(_toDisplayString(row.Message), 1)
                      ])), [
                        [_directive_width, 275]
                      ]),
                      (_ctx.selectedRow && _ctx.selectedRow.Id === row.Id)
                        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_7, _hoisted_9)), [
                            [_directive_width, 25]
                          ])
                        : _createCommentVNode("", true)
                    ], 10, _hoisted_6))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                  _createVNode(_component_swiper, {
                    cssMode: true,
                    navigation: false,
                    pagination: _ctx.pagination,
                    mousewheel: true,
                    keyboard: true,
                    modules: _ctx.modules,
                    class: "mySwiper",
                    onSwiper: _ctx.onSwiper
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.slideEmails, (slide, number) => {
                        return (_openBlock(), _createBlock(_component_swiper_slide, { key: number }, {
                          default: _withCtx(() => [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(slide, (item, index) => {
                              return (_openBlock(), _createElementBlock("div", {
                                key: item.Id + index,
                                class: _normalizeClass(["landing_page_wrapper", _ctx.selectedRow && _ctx.selectedRow.Id === item.Id ? 'selected' : '']),
                                onClick: ($event: any) => (_ctx.selectTemplate(item))
                              }, [
                                _createElementVNode("div", _hoisted_12, [
                                  _hoisted_13,
                                  _createElementVNode("img", {
                                    class: "img-content",
                                    src: item.PreviewPath
                                  }, null, 8, _hoisted_14)
                                ]),
                                _createElementVNode("p", _hoisted_15, _toDisplayString(item.Name), 1),
                                (item.UpdatedAt)
                                  ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(_ctx.lastUpdatedString(item.UpdatedAt)), 1))
                                  : _createCommentVNode("", true)
                              ], 10, _hoisted_11))
                            }), 128))
                          ]),
                          _: 2
                        }, 1024))
                      }), 128)),
                      (_ctx.slideEmails.length)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 0,
                            slot: "button-prev",
                            class: "swiper-button-prev",
                            onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.mySwiper.slidePrev()))
                          }, _hoisted_18))
                        : _createCommentVNode("", true),
                      (_ctx.slideEmails.length)
                        ? (_openBlock(), _createElementBlock("div", {
                            key: 1,
                            slot: "button-next",
                            class: "swiper-button-next",
                            onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.mySwiper.slideNext()))
                          }, _hoisted_20))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }, 8, ["pagination", "modules", "onSwiper"])
                ]))
          ], 512))
        : (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _hoisted_22,
            _hoisted_23,
            _hoisted_24,
            _hoisted_25,
            _createElementVNode("div", _hoisted_26, [
              _createVNode(_component_ap_loader, { class: "lg" })
            ])
          ]))
    ]),
    _: 1
  }, 8, ["name", "title", "onOpen", "cancel-text"]))
}